<template>
  <div class="flex flex-wrap gap-2">
    <div
        v-for="option in options"
        :key="option.value"
        class="btn group inline-flex items-center gap-2 border font-normal text-base"
        :class="baseButtonClasses(option.value)"
        @click="toggle(option.value)"
    >
      <!-- Left Bootstrap Icon(s) -->
      <span class="relative inline-block w-6 h-6">
        <!-- Use dynamic component if 'component' is defined -->
        <SvgIcon
            v-if="option.left && option.svg"
            :name="option.left"
            class="absolute z-10 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-5
           group-[.btn-xs]:w-3 group-[.btn-sm]:w-4 group-[.btn-lg]:w-6 group-[.btn-xl]:w-7"
        />
        <!-- Front Icon (always shown) -->
        <i
            v-else-if="option.left"
            :class="[
            'bi',
            option.left,
            'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
            rotate ? 'rotate-40' : '',
            'group-[.btn-xs]:text-xs group-[.btn-sm]:text-sm group-[.btn-lg]:text-lg group-[.btn-xl]:text-xl'
            ]"
        />
        <!-- Back Icon (if overlap) -->
        <i
            v-if="option.left && option.overlap"
            :class="[
            'bi',
            option.left+'-fill',
            'absolute inset-0 right-2 z-20',
            rotate ? 'rotate-40' : '',
            'group-[.btn-xs]:text-xs group-[.btn-sm]:text-sm group-[.btn-lg]:text-lg group-[.btn-xl]:text-xl'
            ]"
        />
      </span>

      <span class="whitespace-nowrap">{{ option.label }}</span>

      <!-- Right Bootstrap Icon -->
      <i
          v-if="option.right"
          :class="[
          'bi',
          option.right,
          'text-base',
          'group-[.btn-xs]:text-xs',
          'group-[.btn-sm]:text-sm',
          'group-[.btn-lg]:text-lg',
          'group-[.btn-xl]:text-xl'
        ]"
      ></i>
    </div>
  </div>
</template>

<script setup>
import SvgIcon from "@/components/atoms/SvgIcon.vue";

const model = defineModel()
const emit = defineEmits(['change'])
const props = defineProps({
  options: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: false
  },
  padding: {
    type: String,
    default: 'px-6'
  },
  rotate: {
    type: Boolean,
    default: false
  }
})

function isSelected(value) {
  return props.multiple
    ? Array.isArray(model.value) && model.value.includes(value)
    : model.value === value
}

function toggle(value) {
  if (props.multiple) {
    const arr = Array.isArray(model.value) ? [...model.value] : []
    const index = arr.indexOf(value)
    if (index === -1) arr.push(value)
    else arr.splice(index, 1)
    model.value = arr
  } else {
    model.value = value
  }
  emit('change', model.value)
}

function baseButtonClasses(value) {
  return [
    'btn-outline',
    props.padding,
    isSelected(value)
      ? 'bg-accent/10 border-accent text-accent'
      : 'border-base-300 text-base-content/60 hover:bg-base-200'
  ]
}

</script>